import { PageViewTracker } from '../common/components';
import { IntroCTASection } from './sections';
import { IntroActivitySection } from './sections/IntroActivitySection';
import { IntroBenefitsSection } from './sections/IntroBenefitsSection';
import { IntroFaqSection } from './sections/IntroFaqSection';
import { IntroHeroSection } from './sections/IntroHeroSection';

export const IntroPage = () => (
  <>
    {/* 정적 콘텐츠 - 서버에서 HTML로 렌더링 */}
    <div className="flex flex-1 flex-col bg-white">
      <PageViewTracker pageName="curator_signup" musinsaPageName="screen_curator_apply" />
      <IntroHeroSection />
      <IntroActivitySection />
      <IntroBenefitsSection />
      <div className="pb-[72px]!">
        <IntroFaqSection />
      </div>
      {/* 동적 기능 - 클라이언트에서 hydration */}
      <IntroCTASection />
    </div>
  </>
);
